/* eslint-disable jsx-a11y/no-static-element-interactions */
import IconChevronDown from '@zvuk-b2b/react-uikit/ui/icons/ChevronDown';
import IconChevronUp from '@zvuk-b2b/react-uikit/ui/icons/ChevronUp';
import React, { useState } from 'react';
import styles from './index.module.scss';

export type CollapsibleSectionProps = React.PropsWithChildren<{
  title: string;
  children: React.ReactNode;
}>;

const CollapsibleSection = ({ title, children }: CollapsibleSectionProps) => {
  const [isCollapsed, setIsCollapsed] = useState(true);

  const toggleIsCollapsed = React.useCallback(() => setIsCollapsed((value) => !value), []);

  return (
    <div
      className={styles.CollapsibleSection}
      data-testid="cut_music_help_example_panel">
      <div
        className={styles.CollapsibleSectionTitle}
        data-testid="cut_music_help_example_toggle"
        onClick={toggleIsCollapsed}
        onKeyDown={toggleIsCollapsed}>
        {title}
        {isCollapsed ? (
          <IconChevronDown className={styles.CollapsibleSectionChevron} />
        ) : (
          <IconChevronUp className={styles.CollapsibleSectionChevron} />
        )}
      </div>
      {!isCollapsed && (
        <div
          className={styles.CollapsibleSectionContent}
          data-testid="cut_music_help_example_content_wrapper">
          {children}
        </div>
      )}
    </div>
  );
};

export default CollapsibleSection;
